import React, { useState, useEffect } from 'react';
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form';
import { Services } from '@/services/services';
import { Translates } from '@/services/repository/i18n';
import CustomDropdown from '@/components/forms/common/CustomDropdown';

export interface FormBase {
  _general: string;
}

export interface VerifyEmailFormData extends FormBase {
  lang: string
  email: string
}

export interface FormError {
  message: string;
}

export type FormErrors<T> = {
  [K in keyof T]: FormError;
}

export const RegistrationForm = ({
  services,
  onSubmit,
  serverErrors,
  form,
}: {
  services: Services;
  onSubmit: (
    data: VerifyEmailFormData,
    resetForm: () => void
  ) => Promise<void>;
  serverErrors: FormErrors<VerifyEmailFormData> | undefined;
  form: UseFormReturn<VerifyEmailFormData>;
}) => {
  const [translates, setTranslates] = useState<Translates>();
  const {
    setFocus,
    register,
    setError,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = form;

  useEffect(() => {
    form.setValue('lang', services.i18n.defaultLang())
  }, []);

  useEffect(() => {
    services.i18n.get('main').then(setTranslates);
  }, []);

  useEffect(() => {
    if (serverErrors === undefined) {
      return;
    }
    for (let i in serverErrors) {
      const key = i as keyof VerifyEmailFormData;
      setError(key, {
        type: 'server',
        message: translates?.for(serverErrors[key]!.message),
      });
      setFocus(key);
    }
  }, [translates, serverErrors]);

  const handleFormSubmit: SubmitHandler<VerifyEmailFormData> = (data) => {
    onSubmit(data, reset);
  };

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      {/* Email Field */}
      <div className="form-field">
        {/* <label htmlFor="email">{translates.for('forms.verifyemail.fields.email.title')}:</label> */}
        <input
          type="email"
          id="email"
          placeholder={translates.for('forms.verifyemail.fields.email.placeholder')}
          {...register('email', {
            required: translates.for('forms.verifyemail.errors.fields.email.required'),
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              message: translates.for('forms.verifyemail.errors.fields.email.invalid'),
            },
          })}
        />
        {errors.email && <p className="errorMessage">{errors.email.message}</p>}
      </div>

      {/* <div className="form-field">
        <label htmlFor="lang">{translates.for('forms.verifyemail.fields.lang.title')}:</label>
        <div className='custom-select'>
          <CustomDropdown
            name='lang'
            control={form.control}
            options={services.i18n.languages().map((lang) => ({
              value: lang,
              label: translates.for('dicts.langs.' + lang)
            })) || []}
            rules={{
                required: translates.for('forms.verifyemail.errors.fields.lang.required'),
            }}
          />
        </div>
        {errors.lang && <p className="errorMessage">{errors.lang.message}</p>}

      </div> */}
      <input style={{ display: 'none' }} name="ncaptcha" />

      <button className="submit-button" type="submit">
        {translates.for('forms.verifyemail.submit')}
      </button>
      {errors._general && <p className="errorMessage">{errors._general.message}</p>}
    </form>
  )
}